// 32767 is the limit for Firefox
const canvasSizeLimit = 32767;

export default canvasSizeLimit;
